import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Overlay from 'react-bootstrap/Overlay';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class UserAccessTableButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDelete: false,
      confirmRemove: false
    }
  }

  render() {
    return (
      <React.Fragment>
        <Button variant="info" size="sm" style={{ display: this.state.confirmRemove || this.state.confirmDelete ? "inline" : "none" }} onClick={(e) => { this.setState({ confirmRemove: false }); this.setState({confirmDelete: false}) }} className="mr-3">
          No, Back
        </Button>

        {this.props.current_user_is_god &&
        <OverlayTrigger
          key={this.props.user.id}
          placement="top"
          overlay={
            <Tooltip id={'tooltip-confirmation'}>
                 This will permanently delete user from database
            </Tooltip>
          }
        >
          <Button variant="danger" size="sm" style={{ display: this.state.confirmDelete ? "inline" : "none" }} onClick={(e) => { this.props.deleteUser(this.props.user) }}>
            Yes, Delete
          </Button>
        </OverlayTrigger>
          }

        <Button variant="info" href={"/datapulse/users/" + this.props.user.id + "/edit"} style={{ display: !this.state.confirmDelete && !this.state.confirmRemove ? "inline" : "none" }} size="sm" className="mr-3">
          Edit User
        </Button>
        {this.props.current_user_is_god &&
        <Button variant="danger" style={{ display: !this.state.confirmDelete ? "inline" : "none" }} size="sm" onClick={(e) => { this.setState({ confirmDelete: true }) }}>
          Delete User
        </Button>
         }
        <OverlayTrigger
          key={this.props.user.id + "another"}
          placement="top"
          overlay={
            <Tooltip id={'tooltip-confirmation'}>
              This will remove user from the selected Organization only
            </Tooltip>
          }
        >
          <Button variant="danger" size="sm" style={{ display: this.state.confirmRemove ? "inline" : "none" }} onClick={(e) => { this.props.removeUser(this.props.user, this.props.org_id) }}>
            Yes, Remove
          </Button>
        </OverlayTrigger>
        <Button variant="danger" style={{ display: !this.state.confirmRemove ? "inline" : "none" }} size="sm" onClick={(e) => { this.setState({ confirmRemove: true }) }}>
          Remove User
        </Button>
      </React.Fragment>
    );
  }
}

export default UserAccessTableButtons;
